import { Action } from '../../actions';
import { firstReferenceFromReferenceList, mergeObject } from '../../helpers';
import { transformNavigationUserOnPaytmMembershipPlan } from './paytm.transformers';

export function navigationUserOnPaytmMembershipPlanReducer(
  state = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationUserOnPaytmMembershipPlan') {
        const { result, refList } = action.payload;
        return mergeObject<'navigationUserOnPaytmMembershipPlan'>(
          state,
          transformNavigationUserOnPaytmMembershipPlan(result),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/datastore/navigation/paytm/paytm.reducer.ts